import './MainContentAreaAll.css';
import React,{ Component } from 'react'
import InfosysJobComponent from './InfosysJobComponent'
import MphasisJobComponent from './MphasisJobComponent'
import SynechronJobComponent from './SynechronJobComponent'
import AtAndTJobComponent from './AtAndTJobComponent'
import LabCorpJobComponent from './LabCorpJobComponent'
import SelfProjectComponent from './SelfProjectComponent'
import AnyBerLinkJobComponent from './AnyBerLinkJobComponent'
import TCSJobComponent  from './TCSJOBComponent';
import DATAINCJobComponent from './DATAINCJobComponent';
const components={
    DATAINC:DATAINCJobComponent,
    TCS:TCSJobComponent,
    Infosys:InfosysJobComponent,
    Mphasis:MphasisJobComponent,
    Synechron:SynechronJobComponent,
    AtT:AtAndTJobComponent,
    LabCorp:LabCorpJobComponent,
    SelfProject:SelfProjectComponent,
    AnyBerLink: AnyBerLinkJobComponent
}
class Experiencecomponent extends Component{
    constructor(props) {
        super(props)
        this.state={
          CurrentJobComponet:this.props.Jobcomp,
          Previous:''
        }
     }  
     ComponentChangeDetection = (componentName) => {
       this.setState({CurrentJobComponet:componentName })
     }
    render() {
        const TagName =components[this.state.CurrentJobComponet]
        return <TagName handlechange={this.ComponentChangeDetection} />
    }
}
// function Experiencecomponent(props) {
//   // Correct! JSX type can be a capitalized variable.
//   const SpecificStory = components[props.Jobcomp];
//   return <SpecificStory Jobcomp={props.Jobcomp} />;
// }

export default  Experiencecomponent 